// LIBRARIES
import { BORDER_RADIUS, DEVICE_SIZE, DEVICE_TYPE, MARGIN } from "constants/variables";
import styled from "styled-components";

// MISC

//ASSET

export const BodyRow = styled.div`
  height: auto;
  background-color: #E6E7EB;
  border-radius: ${BORDER_RADIUS.radius16};
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: 100%;
  @media (max-width: ${DEVICE_SIZE.TABLET_MAX}) {
    height: auto;
  }  
`;

export const RowContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface VerticalLineProps {
  color: string;
}

export const VerticalLine = styled.div<VerticalLineProps>`
  width: 2px;
  height: 42px;
  background-color: ${props => props.color ? props.color : "#A1A1B3"};
`;

export const BodyRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${MARGIN.fix16};
  width: 100%;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${MARGIN.max8};
  }  
`;

export const Bullet = styled.div<VerticalLineProps>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color ? props.color : "#A1A1B3"};
  position: relative;
`;

interface DashedLineProps {
  isLast: boolean;
}

export const DashedLine = styled.div<DashedLineProps>`
  position: absolute;
  height: 78px;
  display: ${props => props.isLast ? "none" : "flex"};
  top: 14px;
  left: 3px;
  border-left: 2px dashed #A1A1B352;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    display: none;
  }  
`;

export const Time = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${MARGIN.max8};
`;

export const HourWrapper = styled.div`
  width: 45px;
  height: 25px;
  display: flex;
  justify-content: flex-start;
`;



